module.exports = __webpack_public_path__ + "static/media/floral-design-silhouette-svgrepo-com.abff972f.svg";